export const apiOrigin = process.env.REACT_APP_BACKEND_API
  ? process.env.REACT_APP_BACKEND_API
  : 'http://localhost:5000';
export const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE;
